import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  fallbackPath?: string;
  /**
   * page_permissions 에 없는 화면이 권한을 직접 넘길 때. 주지 않으면 지금처럼 page_permissions 로 본다.
   * null = 아직 확인 중(아무것도 그리지 않는다).
   */
  allow?: boolean | null;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  fallbackPath = '/',
  allow
}) => {
  const { userRole, hasPageAccess } = useAuth();
  const location = useLocation();

  // DB 기반 페이지 권한 체크 (page_permissions 테이블)
  // 로그인 체크는 상위 PrivateRoute에서 처리
  if (allow === null) return null;
  if (allow === undefined ? !hasPageAccess(location.pathname) : !allow) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-slate-50">
        <div className="text-center p-8 bg-white rounded-xl shadow-lg border border-slate-200">
          <div className="mb-4">
            <svg className="w-16 h-16 text-slate-400 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          <h3 className="text-lg font-semibold text-slate-900 mb-2">접근 권한이 없습니다</h3>
          <p className="text-slate-600 mb-4">
            현재 권한({userRole})으로는 이 페이지에 접근할 수 없습니다.
          </p>
          <div className="flex gap-3 justify-center">
            <button
              onClick={() => window.history.back()}
              className="px-4 py-2 bg-slate-600 text-white rounded-lg hover:bg-slate-700 transition-colors"
            >
              이전 페이지
            </button>
            <button
              onClick={() => window.location.href = fallbackPath}
              className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors"
            >
              메인으로
            </button>
          </div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;
